module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_9005.d07f49f4.png";